export default function () {
	return {
		attempts: 0,
		clients: [],
		languages: [],
		layout: [],
		login: [],
		register: [],
		user_profile: [],
		social_auth: [],
		use_complete_register: false
	}
}
